<template>
  <b-card class="flex-fill process-order-form">
    <h5 class="py-1 text-center process-order-header">
      PROCESS ORDER
    </h5>

    <div class="px-2 py-1 d-lg-flex">
      <b-col
        cols="12"
        lg="3"
        class="align-items-start"
      >
        <b-form-group label="Sorting Date">
          <b-form-input
            v-model="dateInternal"
            class="w-100"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        lg="3"
        class="align-items-start"
      >
        <b-form-group label="Sorting ID">
          <b-form-input
            v-model="sortingIdInternal"
            placeholder="2024-12-11–Colombo–001"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        lg="3"
        class="align-items-start"
      >
        <b-form-group label="Sorting Category">
          <b-form-input
            v-model="categoryInternal"
            placeholder="Night Operations"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        lg="3"
        class="align-items-start"
      >
        <b-form-group label="Selected Bucket">
          <b-form-input
            v-model="bucketInternal"
            placeholder="A"
            disabled
          />
        </b-form-group>
      </b-col>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BFormGroup, BFormInput, BCol,
} from 'bootstrap-vue'

export default {
  name: 'ProcessOrderForm',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BCol,
  },
  props: {
    date: { type: [String, Date], required: true },
    sortingId: { type: String, required: true },
    category: { type: String, required: true },
    bucketName: { type: String, required: true },
  },

  data() {
    return {
      dateInternal: this.date,
      sortingIdInternal: this.sortingId,
      categoryInternal: this.category,
      bucketInternal: this.bucketName,
    }
  },

  watch: {
    // when internal changes, emit kebab-cased update events for .sync
    dateInternal(val) { this.$emit('update:date', val) },
    sortingIdInternal(val) { this.$emit('update:sorting-id', val) },
    categoryInternal(val) { this.$emit('update:category', val) },
    bucketInternal(val) { this.$emit('update:bucket', val) },

    // keep internals in sync if parent mutates props
    date(val) { this.dateInternal = val },
    sortingId(val) { this.sortingIdInternal = val },
    category(val) { this.categoryInternal = val },
    bucket(val) { this.bucketInternal = val },
  },
}
</script>
<style scoped>
.process-order-header {
    color: #000000 !important;
    background-color: rgba(115, 103, 240, 0.2);
    border-radius: 0.5rem 0.5rem 0 0;
    font-weight: 700;
}
.process-order-form .card-body {
    padding: 0 !important;
}
</style>
